import React, { useState, useEffect, useCallback, useRef } from 'react';
import { withTranslation } from '../../../ChildrenContext.js';
import PropTypes from 'prop-types';
import GoalsPageListComponent from '../GoalsPageList/GoalsPageList.container';
import GoalsPageFilterComponent from '../GoalsPageFilter/GoalsPageFilter.container';
import config from '../../../../config';
import query from '../../../../helpers/query';
import { useTemplateConfig } from '../../../../context/TemplateConfigContext';

const images = {
    filterMobile: require('shared_img/offers/filter-mobile.svg'),
};

const GoalsPageContainer = ({ 
    location, 
    searchString = '', 
    accessGranted = '', 
    offerLocales = '', 
    locales, 
    onUpdate, 
    t, 
    ...props 
}) => {
    const { assets } = useTemplateConfig();
    const parsedQuery = query.parse(location && location.query);
    const q = location && location.query;

    const [state, setState] = useState({
        page: q && q.page && +q.page || config.initialPage,
        modalIsVisible: false,
        searchString: parsedQuery.searchString || searchString,
        accessGranted: parsedQuery.accessGranted || accessGranted,
        offerLocales: parsedQuery.offerLocales || offerLocales,
        statuses: parsedQuery.statuses || [{value: 'active'}]
    });

    const lastQueryRef = useRef('');
    const lastRequestRef = useRef('');

    const buildRequestState = useCallback((currentState) => {
        const trimmedSearch = (currentState.searchString || '').trim();
        return {
            ...currentState,
            searchString: (!trimmedSearch || trimmedSearch.length >= 3) ? trimmedSearch : ''
        };
    }, []);

    const onAction = useCallback((stateUpdate) => {
        setState(prevState => ({
            ...prevState,
            ...stateUpdate
        }));
    }, []);

    const handleSearchChange = useCallback((e) => {
        const value = e.target.value;
        onAction({ searchString: value });
    }, [onAction]);

    const openFilterModal = useCallback(() => {
        setState(prevState => ({
            ...prevState,
            modalIsVisible: true
        }));
    }, []);

    const onClose = useCallback(() => {
        setState(prevState => ({
            ...prevState,
            modalIsVisible: false
        }));
    }, []);

    useEffect(() => {
        if (locales !== state.locales) {
            setState(prevState => ({
                ...prevState,
                locales: locales,
                modalIsVisible: false
            }));
        }
    }, [locales, state.locales]);

    // Apply side-effects (update parent, sync URL) after state changes to avoid updates during render
    useEffect(() => {
        const requestState = buildRequestState(state);
        const requestSerialized = JSON.stringify(query.stringify({ ...requestState }));
        if (requestSerialized !== lastRequestRef.current) {
            if (onUpdate) {
                onUpdate(requestState);
            }
            lastRequestRef.current = requestSerialized;
        }

        const serialized = JSON.stringify(query.stringify({ ...state }));
        if (serialized !== lastQueryRef.current) {
            query.replace(state);
            lastQueryRef.current = serialized;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state, onUpdate, buildRequestState]);

    const staticNames = (t && t.offersPage && t.offersPage.goalsList) || {};

    return (
        <div className="ibox-content">
            <div className="filter-container">
                <div className="search">
                    <label className="input-label bold">{staticNames.byGoalName} <i className="fa fa-search"></i> </label>
                    <input
                        className="form-control"
                        type="text"
                        placeholder={staticNames.goalName}
                        pattern=".{3,}"
                        title={staticNames.minSymbols}
                        onChange={handleSearchChange}
                        value={state.searchString}
                    />
                </div>
                <GoalsPageFilterComponent
                    onAction={onAction}
                    modalIsVisible={state.modalIsVisible}
                    searchString={state.searchString}
                    onClose={onClose}
                />
                <div className="order-filer" onClick={openFilterModal}>
                    <img className="wrap__desktop" src={assets.icons.filter} alt="order filter"/>
                    <img className="wrap__mobile" src={images.filterMobile} alt="order filter"/>
                </div>
            </div>
            <GoalsPageListComponent
                onAction={onAction}
                page={state.page}
            />
        </div>
    );
};

GoalsPageContainer.propTypes = {
    location: PropTypes.object,
    searchString: PropTypes.string,
    accessGranted: PropTypes.string,
    offerLocales: PropTypes.string,
    locales: PropTypes.array,
    onUpdate: PropTypes.func,
    t: PropTypes.object
};

export default withTranslation(GoalsPageContainer);